"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchError = void 0;
class FetchError extends Error {
    constructor({ message, response, data }) {
        // Pass remaining arguments to parent constructor
        super(message);
        // Maintains proper stack trace for where our error was thrown
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, FetchError);
        }
        this.name = 'FetchError';
        this.response = response;
        this.data = data !== null && data !== void 0 ? data : { errors: [{ message: 'Unknown error' }] };
    }
}
exports.FetchError = FetchError;
function fetchJson(input, init) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(input, init);
        let data;
        if (response.status !== 204) {
            data = yield response.json();
        }
        if (response.ok) {
            return data;
        }
        throw new FetchError({
            message: response.statusText,
            response,
            data
        });
    });
}
exports.default = fetchJson;
